/* Quick-shop mini-PDP variant bottom-sheet + gallery sync.
   Loaded once globally from layout/theme.liquid.

   Previously this was an inline <script> emitted by snippets/quick-shop.liquid,
   but that snippet only renders eagerly when product cards use
   quick_shop_type='rendered'. Most NF surfaces (homepage, search drawer,
   recently-viewed, predictive-search) use quick_shop_type='remote', which
   renders quick-shop-placeholder.liquid (no script) and fetches the real
   quick-shop content via Section Rendering API on first click. theme.js's
   QuickShop._updateContent extracts ONLY the <quick-shop> element from the
   SRA response with `parser.querySelector('quick-shop')`, so any sibling
   <script> tag was discarded. Net effect: variant trigger never opened
   bottom-sheet on cards using remote loading.

   By loading this once globally, the click handlers attach at page load
   regardless of whether quick-shop is rendered eagerly or fetched via SRA. */
(function () {
  if (window.__qsVariantSheetInit) return;
  window.__qsVariantSheetInit = true;

  // Thumbnail click → scroll gallery to selected media
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-qs-thumb-target]');
    if (thumb) {
      e.preventDefault();
      var qs = thumb.closest('quick-shop');
      var mediaId = thumb.getAttribute('data-qs-thumb-target');
      var gallery = qs && qs.querySelector('[data-qs-gallery]');
      var slide = gallery && gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide && gallery) {
        var left = slide.offsetLeft - gallery.offsetLeft;
        gallery.scrollTo({ left: left, behavior: 'smooth' });
      }
      var allThumbs = qs.querySelectorAll('[data-qs-thumb-target]');
      allThumbs.forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      return;
    }
  });

  // Variant trigger / bottom-sheet open + close
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-qs-variant-trigger]');
    if (trigger) {
      e.preventDefault();
      var wrapper = trigger.closest('.product-form__variant');
      var sheet = wrapper && wrapper.querySelector('[data-qs-variant-sheet]');
      if (!sheet) {
        var portaled = [].slice.call(document.body.children).find(function (el) {
          return el.matches && el.matches('.qs-variant-sheet') && el.__qsOriginalTrigger === trigger;
        });
        sheet = portaled;
      }
      if (!sheet) return;
      if (sheet.classList.contains('is-open')) {
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        if (sheet.__qsOriginalParent) {
          try { sheet.__qsOriginalParent.appendChild(sheet); } catch (e) {}
        }
        return;
      }
      // Sync `is-selected` to the actually-selected variant before opening,
      // in case it changed since SSR (swatch click on the card, etc.).
      var qsForSync = sheet.__qsOriginalParent ? sheet.__qsOriginalParent.closest('quick-shop') : trigger.closest('quick-shop');
      var hiddenForSync = qsForSync && qsForSync.querySelector('input[name="id"]');
      if (qsForSync && hiddenForSync && hiddenForSync.value) {
        syncVariantSelectionToCurrent(qsForSync, hiddenForSync.value);
      }
      var isDesktop = window.matchMedia('(min-width: 641px)').matches;
      if (isDesktop) {
        sheet.classList.add('is-open');
        sheet.classList.add('qs-variant-sheet--inline');
      } else {
        if (sheet.parentElement !== document.body) {
          sheet.__qsOriginalParent = sheet.parentElement;
          sheet.__qsOriginalTrigger = trigger;
          document.body.appendChild(sheet);
        }
        sheet.classList.add('is-open');
        sheet.classList.remove('qs-variant-sheet--inline');
      }
      sheet.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      return;
    }

    // Click outside an open inline (desktop) sheet → close it
    var openInline = document.querySelector('.qs-variant-sheet.is-open.qs-variant-sheet--inline');
    if (openInline && !e.target.closest('[data-qs-variant-sheet]') && !e.target.closest('[data-qs-variant-trigger]')) {
      openInline.classList.remove('is-open');
      openInline.setAttribute('aria-hidden', 'true');
      var wrap = openInline.closest('.product-form__variant');
      var trig = wrap && wrap.querySelector('[data-qs-variant-trigger]');
      if (trig) trig.setAttribute('aria-expanded', 'false');
      return;
    }

    var closer = e.target.closest('[data-qs-variant-close]');
    if (closer) {
      var sheet2 = closer.closest('[data-qs-variant-sheet]');
      if (!sheet2) return;
      sheet2.classList.remove('is-open');
      sheet2.setAttribute('aria-hidden', 'true');
      var trig = sheet2.__qsOriginalTrigger || (sheet2.__qsOriginalParent && sheet2.__qsOriginalParent.querySelector('[data-qs-variant-trigger]'));
      if (trig) trig.setAttribute('aria-expanded', 'false');
      if (sheet2.__qsOriginalParent) {
        try { sheet2.__qsOriginalParent.appendChild(sheet2); } catch (e) {}
      }
      return;
    }

    var option = e.target.closest('[data-qs-variant-option]');
    if (option) {
      var variantId = option.getAttribute('data-variant-id');
      var label = option.getAttribute('data-variant-title');
      var sheet3 = option.closest('[data-qs-variant-sheet]');
      var wrapper3 = (sheet3 && (sheet3.__qsOriginalParent || sheet3.closest('.product-form__variant'))) || null;
      var qsEl = (sheet3 && sheet3.__qsOriginalParent) ? sheet3.__qsOriginalParent.closest('quick-shop') : option.closest('quick-shop');
      if (!wrapper3) return;
      wrapper3.querySelectorAll('[data-qs-variant-option]').forEach(function (o) {
        o.classList.toggle('is-selected', o === option);
        o.setAttribute('aria-selected', o === option ? 'true' : 'false');
      });
      var triggerLabel = wrapper3.querySelector('[data-qs-variant-label]');
      if (triggerLabel) triggerLabel.textContent = label;
      var nativeSelects = wrapper3.querySelectorAll('select');
      nativeSelects.forEach(function (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].textContent.trim().toLowerCase().indexOf(label.toLowerCase()) === 0) {
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      });
      if (qsEl && variantId) {
        try {
          var jsonScript = qsEl.querySelector('script[type="application/json"][id^="ProductJson-"]');
          if (jsonScript) {
            var productData = JSON.parse(jsonScript.textContent);
            var matched = (productData.variants || []).find(function (v) { return String(v.id) === String(variantId); });
            var mediaId = matched && matched.featured_media && matched.featured_media.id;
            if (mediaId) {
              var gallery = qsEl.querySelector('[data-qs-gallery]');
              var targetSlide = gallery && gallery.querySelector('[data-media-id="' + mediaId + '"]');
              if (targetSlide && gallery) {
                var left = targetSlide.offsetLeft - gallery.offsetLeft;
                gallery.scrollTo({ left: left, behavior: 'smooth' });
              }
              var thumbs = qsEl.querySelectorAll('[data-qs-thumb-target]');
              thumbs.forEach(function (t) {
                t.classList.toggle('is-active', t.getAttribute('data-qs-thumb-target') === String(mediaId));
              });
            }
          }
        } catch (err) {}
      }
      sheet3.classList.remove('is-open');
      sheet3.setAttribute('aria-hidden', 'true');
      var trig2 = wrapper3.querySelector('[data-qs-variant-trigger]');
      if (trig2) trig2.setAttribute('aria-expanded', 'false');
      if (sheet3.__qsOriginalParent) {
        try { sheet3.__qsOriginalParent.appendChild(sheet3); } catch (e) {}
      }
    }
  });

  /* Sync the variant drawer + trigger label to whichever variant the
     hidden `input[name="id"]` currently holds. SSR renders `is-selected`
     for `selected_or_first_available_variant`, but the product-card link
     may point to a different variant (swatch click, ?variant= in URL).
     Without this sync the drawer always shows the default highlighted on
     mobile (where the user doesn't click an option to open the portaled
     bottom-sheet before viewing it). */
  function syncVariantSelectionToCurrent(qsEl, variantId) {
    if (!qsEl || !variantId) return;
    // Find the drawer — may have been portaled to document.body on mobile.
    var sheet = qsEl.querySelector('[data-qs-variant-sheet]');
    if (!sheet) {
      sheet = [].slice.call(document.body.children).find(function (el) {
        return el.matches && el.matches('.qs-variant-sheet') &&
               el.__qsOriginalParent && qsEl.contains(el.__qsOriginalParent);
      });
    }
    if (!sheet) return;
    var match = sheet.querySelector('[data-qs-variant-option][data-variant-id="' + variantId + '"]');
    if (!match) return;
    sheet.querySelectorAll('[data-qs-variant-option]').forEach(function (o) {
      o.classList.toggle('is-selected', o === match);
      o.setAttribute('aria-selected', o === match ? 'true' : 'false');
    });
    var triggerLabel = qsEl.querySelector('[data-qs-variant-label]');
    var label = match.getAttribute('data-variant-title');
    if (triggerLabel && label) triggerLabel.textContent = label;
  }

  /* Sync the qs-gallery to the currently-selected variant's featured media on
     initial open. Without this, the gallery starts at slide 0 even when
     current_variant.id (set by the product-card link) points to a variant
     whose featured_media is later in the list. */
  function syncGalleryToCurrentVariant(qsEl) {
    if (!qsEl || qsEl.__qsGallerySynced) return;
    var jsonScript = qsEl.querySelector('script[type="application/json"][id^="ProductJson-"]');
    if (!jsonScript) return;
    var hidden = qsEl.querySelector('input[name="id"]');
    var variantId = hidden && hidden.value;
    if (!variantId) return;
    // Sync the variant drawer + trigger label regardless of whether the
    // gallery sync below succeeds.
    syncVariantSelectionToCurrent(qsEl, variantId);
    var gallery = qsEl.querySelector('[data-qs-gallery]');
    if (!gallery) {
      qsEl.__qsGallerySynced = true;
      return;
    }
    try {
      var productData = JSON.parse(jsonScript.textContent);
      var matched = (productData.variants || []).find(function (v) { return String(v.id) === String(variantId); });
      var mediaId = matched && matched.featured_media && matched.featured_media.id;
      if (!mediaId) { qsEl.__qsGallerySynced = true; return; }
      var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) {
        var left = slide.offsetLeft - gallery.offsetLeft;
        gallery.scrollTo({ left: left, behavior: 'auto' });
      }
      var thumbs = qsEl.querySelectorAll('[data-qs-thumb-target]');
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-qs-thumb-target') === String(mediaId));
      });
      qsEl.__qsGallerySynced = true;
    } catch (e) {}
  }

  /* Watch for quick-shop content being injected (theme.js _updateContent replaces
     .quick-shop__wrapper.innerHTML after SRA fetch). When the gallery appears,
     sync it to the current variant once. */
  var contentObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        var qsEl = (n.matches && n.matches('quick-shop')) ? n : (n.closest && n.closest('quick-shop'));
        if (!qsEl) {
          var inner = n.querySelector && n.querySelector('quick-shop');
          if (inner) qsEl = inner;
        }
        if (qsEl && qsEl.querySelector('[data-qs-gallery]')) {
          qsEl.__qsGallerySynced = false;
          syncGalleryToCurrentVariant(qsEl);
        }
      }
    }
  });
  contentObserver.observe(document.body, { childList: true, subtree: true });

  /* Already-rendered quick-shops on first script run */
  document.querySelectorAll('quick-shop').forEach(syncGalleryToCurrentVariant);
})();
